import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declaration } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  declaration: Partial<Declaration>;
  reason: string;
}

export const useInvalidateOneLv = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declaration, reason }: HookProps) => {
      if (declaration.customsState) {
        await request({
          path: 'idms/invalidate',
          method: 'POST',
          authenticate: true,
          dataObject: { declarationId: declaration._id, reason },
        });
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declaration._id] });
      toast.success('Invalidation request was sent!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending the invalidation request!`);
    },
  });
};
